/**
 * @name: 数据统计-礼品卡兑换记录接口文件
 * @author: itmobai
 * @date: 2023-12-07 16:39
 * @description： 数据统计-礼品卡兑换记录接口文件
 * @update: 2023-12-07 16:39
 */
import {get, postJ} from "@/request"
import {IPageRes} from "@/apis/page";
import {IStatisticsExchangeParam, IStatisticsExchangeRes} from "@/apis/statistics/exchange/types";

/**
 * 分页查询
 * @param params
 */
export const queryGiftCartExchangeByPageApi = (params: IStatisticsExchangeParam) => get<IStatisticsExchangeRes>("/card/data/statistics/queryGiftCartExchangeByPage", params)
/**
 * 导出
 * @param params
 */
export const giftCartExchangeExportApi = (params: IStatisticsExchangeParam) => get("/card/data/statistics/giftCartExchangeExport", params, "blob")
